import script from "./JoinView.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinView.vue?vue&type=script&setup=true&lang=js"

import "./JoinView.vue?vue&type=style&index=0&id=434f2fc0&lang=scss"

const __exports__ = script;

export default __exports__